import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxEiffageSalarie extends Component {

    static defaultProps = {
        label: "Salariés Eiffage",
        placeholder: "Salariés Eiffage",
    };

    render = () => {

        let fetchMethod = () => new Promise((resolve, reject) => {
            const options = [
                { key: 1, text: "Construction" },
                { key: 2, text: "Infrastructures" },
                { key: 3, text: "Energie Systèmes" },
                { key: 4, text: "Immobilier" },
                { key: 5, text: "Holding" },
                { key: 6, text: "Concessions" }
            ];
            resolve({ codeRetour: 0, reponseAPIobjet: options });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
        />;
    };

};